import { c as m } from "../lit-element-8JrrHldg.js";
import { P as l } from "../pwc-bool-option-NsXoMkYh.js";
var f = Object.defineProperty, P = Object.getOwnPropertyDescriptor, b = (n, o, r, t) => {
  for (var e = t > 1 ? void 0 : t ? P(o, r) : o, c = n.length - 1, s; c >= 0; c--)
    (s = n[c]) && (e = (t ? s(o, r, e) : s(e)) || e);
  return t && e && f(o, r, e), e;
};
const a = "pwc-checkbox-option";
let p = class extends l {
  constructor() {
    super(...arguments), this.boolType = "checkbox";
  }
};
p.tagName = a;
p = b([
  m(a)
], p);
export {
  p as PwcCheckboxOption
};
